import { render, staticRenderFns } from "./FichaForm.vue?vue&type=template&id=48ebca71&"
import script from "./FichaForm.vue?vue&type=script&lang=js&"
export * from "./FichaForm.vue?vue&type=script&lang=js&"
import style0 from "./FichaForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports